const hasValue = (value) => value !== undefined && value !== null;

/**
 * Builds the multi-path update that deletes a folder (and only the folder):
 * - removes the folder node, its children index and its contents index;
 * - removes the folder from its parent children index;
 * - moves direct subfolders to the parent folder;
 * - clears `folderID` on every linked entity (the entities are NOT deleted).
 *
 * `getEntityPaths(contentID)` must return the entity record paths that hold a
 * `folderID` field (empty for domains that only keep the membership index).
 */
export const buildDeleteFolderUpdates = ({
  advertiserID,
  folderID,
  parentFolderID,
  childFolderIDs = [],
  contentIDs = [],
  foldersRoot,
  childrenRoot,
  contentsRoot,
  getEntityPaths = () => [],
}) => {
  const updates = {};

  updates[`${foldersRoot}/${advertiserID}/${folderID}`] = null;
  updates[`${childrenRoot}/${advertiserID}/${folderID}`] = null;
  updates[`${contentsRoot}/${advertiserID}/${folderID}`] = null;

  if (hasValue(parentFolderID)) {
    updates[`${childrenRoot}/${advertiserID}/${parentFolderID}/${folderID}`] =
      null;

    childFolderIDs.forEach((childFolderID) => {
      updates[
        `${foldersRoot}/${advertiserID}/${childFolderID}/parentFolderID`
      ] = parentFolderID;
      updates[
        `${childrenRoot}/${advertiserID}/${parentFolderID}/${childFolderID}`
      ] = true;
    });
  }

  contentIDs.forEach((contentID) => {
    getEntityPaths(contentID).forEach((entityPath) => {
      updates[`${entityPath}/folderID`] = null;
    });
  });

  return updates;
};
